export default "__VITE_ASSET__FcR_IUHY__"